import React, {Component} from "react";
import axios from "axios";
import baseURL from "../../../config";
import moment from "moment";
import {Button, DatePicker, Input, Select, message} from "antd";
import fileDownload from "js-file-download";
import "./AccountantList.scss";

// const
function disabledDate(future) {
  let customDate = moment().subtract(1, "months");
  return future && future > moment(customDate, "MMM Do YYYY");
}

const FIRST_NAP_REPORT_YEAR = 2022;
const CURRENT_YEAR = moment().year();
const NAP_REPORT_YEARS = [];
for (let year = CURRENT_YEAR; year >= FIRST_NAP_REPORT_YEAR; year--) {
  NAP_REPORT_YEARS.push(year);
}
const DEFAULT_NAP_REPORT_YEAR = Math.max(FIRST_NAP_REPORT_YEAR, CURRENT_YEAR - 1);

const GENERIC_REPORT_ERROR = "Неуспешно генериране на отчета. Опитайте отново.";

/**
 * Maps a paymentReports/ (email + XML-by-month) failure to a Bulgarian
 * message, per the endpoint's existing (unchanged) error contract.
 */
function paymentReportErrorMessage(err) {
  const status = err?.response?.status;
  const body = err?.response?.data;
  const bodyMessage = typeof body === "string" ? body : body?.message;

  if (status === 404) {
    return "Текущият месец не е позволен — изберете предишен";
  }
  if (status === 400 && bodyMessage === "No records found for the given date") {
    return "Няма записи за избрания месец";
  }
  if (status === 400 && bodyMessage === "Please provide date and reportType") {
    return "Изберете месец";
  }
  return GENERIC_REPORT_ERROR;
}

/** Maps a getnapreport?year= failure to a Bulgarian message. */
function yearReportErrorMessage(status, year) {
  if (status === 404) {
    return `Няма транзакции за ${year}`;
  }
  if (status === 400) {
    return "Невалидна година";
  }
  return GENERIC_REPORT_ERROR;
}

class AccountantList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountantListData: [],
      datePick: "",
      email: "",
      year: DEFAULT_NAP_REPORT_YEAR,
      isSendingEmail: false,
      isDownloadingXml: false,
      isDownloadingTransactions: false,
    };
  }

  onDatepicker = (date, dateString) => {
    this.setState({datePick: dateString});
  };

  onEmailChange = (e) => {
    this.setState({email: e.target.value});
  };

  onYearChange = (year) => {
    this.setState({year});
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (!this.state.datePick) {
      message.error("Изберете месец");
      return;
    }
    if (!this.state.email) {
      message.error("Въведете имейл");
      return;
    }
    const payload = {
      email: this.state.email,
      date: this.state.datePick,
      reportType: "EMAIL",
    };
    this.setState({isSendingEmail: true});
    axios
      .post(`${baseURL}/api/v1/paymentReports/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        message.success(`Отчетът е изпратен на ${this.state.email}`);
      })
      .catch((err) => {
        message.error(paymentReportErrorMessage(err));
      })
      .finally(() => {
        this.setState({isSendingEmail: false});
      });
  };

  onDownloadTransactions = (e) => {
    e.preventDefault();
    const year = this.state.year;
    this.setState({isDownloadingTransactions: true});
    axios
      .get(`${baseURL}/api/v1/admins/getnapreport`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {year},
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `YearReport${year}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        message.success("Файлът е изтеглен");
      })
      .catch((err) => {
        message.error(yearReportErrorMessage(err?.response?.status, year));
      })
      .finally(() => {
        this.setState({isDownloadingTransactions: false});
      });
  };

  onDownload = (e) => {
    e.preventDefault();
    if (!this.state.datePick) {
      message.error("Изберете месец");
      return;
    }
    const filename = `${this.state.datePick}.xml`;
    const payload = {
      date: this.state.datePick,
      reportType: "DOWNLOAD",
    };
    this.setState({isDownloadingXml: true});
    axios
      .post(`${baseURL}/api/v1/paymentReports/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        fileDownload(res.data, filename);
        message.success("Файлът е изтеглен");
      })
      .catch((err) => {
        message.error(paymentReportErrorMessage(err));
      })
      .finally(() => {
        this.setState({isDownloadingXml: false});
      });
  };

  render() {
    return (
      <div className="table-rep-plugin">
        <div className="table-responsive mb-0 al-wrapper" data-pattern="priority-columns">
          <div className="al-row">
            <label className="al-label" htmlFor="al-email">
              Имейл
            </label>
            <Input
              id="al-email"
              className="al-input"
              size="large"
              value={this.state.email}
              onChange={this.onEmailChange}
            />
            <Button
              className="al-button"
              type="primary"
              onClick={this.onSubmit}
              loading={this.state.isSendingEmail}
            >
              Изпрати
            </Button>
          </div>

          <div className="al-row">
            <DatePicker
              className="al-month-picker"
              size="large"
              disabledDate={disabledDate}
              onChange={this.onDatepicker}
              picker="month"
              placeholder="Избери месец"
            />
            <Button
              className="al-button"
              type="primary"
              onClick={this.onDownload}
              loading={this.state.isDownloadingXml}
            >
              Изтегли XML
            </Button>
          </div>

          <div className="al-row">
            <Select
              className="al-year-select"
              size="large"
              value={this.state.year}
              onChange={this.onYearChange}
              options={NAP_REPORT_YEARS.map((year) => ({value: year, label: year}))}
            />
            <Button
              className="al-button"
              type="primary"
              onClick={this.onDownloadTransactions}
              loading={this.state.isDownloadingTransactions}
            >
              Изтегли транзакции
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountantList;
